module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Sitzung_starten.38a846e7.svg";